<template>
  <div class="scount-layout">
    <slot v-if="mobile"></slot>
    <div v-if="!mobile">
      <div v-if="type === 'banners' && banners" class="scount-layout__banners">
        <div v-if="imageLeft" class="banners__item banners__item_left">
          <div :style="{ 'background-image': `url(${imageLeft})` }"></div>
        </div>
        <div v-if="imageTop" class="banners__item banners__item_top">
          <div :style="{ 'background-image': `url(${imageTop})` }"></div>
        </div>
        <div v-if="imageRight" class="banners__item banners__item_right">
          <div :style="{ 'background-image': `url(${imageRight})` }"></div>
        </div>
      </div>
      <div 
        class="scount-layout__wrapper"
        :class="type === 'general' ? 'scount-layout__wrapper_fullwidth' : ''"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import BannerTop from '../assets/img/banner-top.png';
import BannerSide from '../assets/img/banner-side.png';

export default {
  name: 'Layout',
  props: {
    /**
     * Тип раскладки
     */
    type: {
      type: String,
      default: 'general',
      validator(value) {
        return ['', 'general', 'banners'].indexOf(value) !== -1;
      },
    },
    /**
     * Объект с картинками баннеров
     */
    banners: {
      type: Object,
    },
  },
  data() {
    return {
      mobile: false,
    };
  },
  computed: {
    imageLeft() {
      return this.banners && this.banners.left && this.banners.left.image || BannerSide;
    },
    imageTop() {
      return this.banners && this.banners.top && this.banners.top.image || BannerTop;
    },
    imageRight() {
      return this.banners && this.banners.right && this.banners.right.image || BannerSide;
    },
  },
  methods: {
    onResize() {
      this.mobile = window.innerWidth < 768;
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style lang="scss" scoped>
  @import "./Layout";
</style>
